import { ScheduledItemConfig } from '../core/services/scheduler/scheduled-task-config.interface';
import { ENV, REST } from '../environments/environment';
import { ENVIRONMENTS } from '../environments/environments';

export class AppConfig { // implements IAppConfig

    static logRestRequests = false; // isInArray(ENV.name, [ENVIRONMENTS.DEV, ENVIRONMENTS.E2E]);

    static debugQueries = false;

    static offlineMode = ENV.name === ENVIRONMENTS.E2E;

    static DATE_FORMATS = {
        YMD: 'YYYY-MM-DD',
        DMY: 'DD-MM-YYYY',
        HM_DMY: 'HH:mm DD-MM-YYYY',
        HM_Day_Month_Year: 'HH:mm Do MMMM YYYY',
        DAYNAME_DAY_MONTHNAME_YEAR: 'ddd Do MMM YYYY', // https://date-fns.org/docs/format,
        IMG_NAME: 'YYYYMMDD_HHmmss'
    };

    static SPLAT_IMAGE_MAP = {

        // icons large
        'arrow-blue': 'assets/splat/icons-large/arrow-blue.png',
        'arrow-red': 'assets/splat/icons-large/arrow-red.png',
        'circle-blue': 'assets/splat/icons-large/circle-blue.png',
        'circle-red': 'assets/splat/icons-large/circle-red.png',
        'cross-blue': 'assets/splat/icons-large/cross-blue.png',
        'cross-red': 'assets/splat/icons-large/cross-red.png',

        // icons small
        'arrow-blue-small': 'assets/splat/icons-small/arrow-blue.png',
        'arrow-red-small': 'assets/splat/icons-small/arrow-red.png',
        'circle-blue-small': 'assets/splat/icons-small/circle-blue.png',
        'circle-red-small': 'assets/splat/icons-small/circle-red.png',
        'cross-blue-small': 'assets/splat/icons-small/cross-blue.png',
        'cross-red-small': 'assets/splat/icons-small/cross-red.png',

        // backgrounds
        artic: 'assets/splat/artic.png',
        bike: 'assets/splat/bike.png',
        cab: 'assets/splat/cab.png',
        car: 'assets/splat/car.png',
        'car-exploded': 'assets/splat/car-exploded.png',
        'car-reversed': 'assets/splat/car-reversed.png',
        'caravan': 'assets/splat/caravan.png',
        quad: 'assets/splat/quad.png',
        tractor: 'assets/splat/tractor.png',
        trailer: 'assets/splat/trailer.png',
        truck: 'assets/splat/truck.png',
        van: 'assets/splat/van.png'
    };

    static JOB_LIST_PAGE = {
        limit: 25,
        defaultSortBy: 'created',
        defaultSortDirection: 0

    };

    ENTITY_SYNC_DOWN_LIST = [
        'account',
        'accessGroup',
        'contactType',
        'jobStatus',
        'taskType',
        'jobType',
        'lookupType',
        'categoryGroup',
        'reportLayout',
        'form',
        'contact',
        'lookup'
    ];

    SCHEDULE: Array<ScheduledItemConfig> = [
        {
            id: 'syncUp',
            serviceName: 'SyncUpService',
            fnName: 'run',
            args: [],
            interval: 20,
            timeout: 600, // sec
            priority: 10,
            deps: '*',
            requirements: {
                online: true,
                authenticated: true
            }
        }
    ];

    CLEAN_UP_AGE = 60 * 1000; // 5min;

    REST = REST;

    PUSH = {
        ENDPOINT: 'http://172.30.1.199:3002/api',
        APP_ID: '594fc4bea7e3614246dfe25a'
    };

    getOffLineMode(): boolean {
        return AppConfig.offlineMode;
    }

    setOffLineMode(mode: boolean): void {
        AppConfig.offlineMode = mode;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts